import type { FaireProductEntity } from "../../entity_types/product";

export const p_a8hv3ezy6k: FaireProductEntity = {
  token: "p_a8hv3ezy6k",
  type: "product",
  name: "Colorful Handmade Ceramic Evil Eye Bowl",
  brandToken: "b_bp2qh0z57y",
  brandName: "Nai Gifts",
  imageUrl:
    "https://cdn.faire.com/fastly/d47a32156e6292d2ac0a72dbe6c3cf2bd26a2bb7b6527661e57cc1352b34070e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/a68d9d398ced02a2c68f388f5e41b8d9941f311b6c23f00f980378ee7a3b1dc2.jpeg",
    "https://cdn.faire.com/fastly/7dc810a18b71706c7f2c9fccb002014c371294e846aa51fe1a92c17ed168d38c.jpeg",
    "https://cdn.faire.com/fastly/d53242f7468b3d258a5ef328ab0b232efd70940314996cd03279d4eca0bba8d5.jpeg",
  ],
  priceDollars: 4.85,
  description:
    "This colorful handmade ceramic evil eye bowl features a stunning combination of turquoise,white,orange,red and blue glazes,perfect for both decorative and everyday use.Each piece is uniquely crafted showcasing intricate hand painted details.\nIdeal as a gift or a statement piece in any home,it embodies cultural symbolism and artistic charm.\nLead free \nHand wash is recommended to preserve the bowl’s finish ",
  tags: [],
  msrpDollars: 9.7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:01:36.024Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
